"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Product_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const events_1 = require("../events");
const column_numeric_transformer_1 = require("../transformers/column-numeric-transformer");
const contact_profile_enum_1 = require("./contact-profile-enum");
const job_product_1 = require("./job_product");
const oem_1 = require("./oem");
const product_service_1 = require("./product-service");
const product_bundle_1 = require("./product_bundle");
const product_opportunity_1 = require("./product_opportunity");
const product_type_enum_1 = require("./product_type_enum");
let Product = Product_1 = class Product {
};
Product.EVENTS = (0, events_1.makeEventsForClass)(Product_1);
Product.NAME_GENERATED_PREFIX = 'PDT';
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], Product.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('text', {
        name: 'name',
    }),
    __metadata("design:type", String)
], Product.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('varchar', {
        nullable: false,
        name: 'name_generated',
        length: 80,
        default: () => "gid_generate_name('PDT', 10)",
        unique: true,
    }),
    __metadata("design:type", String)
], Product.prototype, "nameGenerated", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Item Id' }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 80,
        name: 'item_id',
    }),
    __metadata("design:type", String)
], Product.prototype, "item_id", void 0);
__decorate([
    (0, typeorm_1.Column)('numeric', {
        nullable: true,
        precision: 18,
        scale: 6,
        name: 'price_purchasing_net',
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], Product.prototype, "price_purchasing_net", void 0);
__decorate([
    (0, typeorm_1.Column)('numeric', {
        nullable: true,
        precision: 18,
        scale: 6,
        name: 'price_selling_net',
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], Product.prototype, "price_selling_net", void 0);
__decorate([
    (0, typeorm_1.Column)('numeric', {
        nullable: true,
        name: 'price_listing',
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], Product.prototype, "price_listing", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'OEM', isCascadeRelation: false }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => oem_1.Oem, (oem) => oem.products, {
        cascade: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: 'oem_id' }),
    __metadata("design:type", oem_1.Oem)
], Product.prototype, "oem", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 30,
        name: 'ean',
    }),
    __metadata("design:type", String)
], Product.prototype, "ean", void 0);
__decorate([
    data_ui_1.DataUi.Override({ isRichText: true }),
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'description',
    }),
    __metadata("design:type", String)
], Product.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'url',
    }),
    __metadata("design:type", String)
], Product.prototype, "url", void 0);
__decorate([
    (0, typeorm_1.Column)('numeric', {
        nullable: true,
        precision: 5,
        scale: 0,
        name: 'vat',
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], Product.prototype, "vat", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Product Type', isCascadeRelation: false }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => product_type_enum_1.ProductTypeEnum, (productTypeEnum) => productTypeEnum.products, {
        cascade: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: 'product_type_id' }),
    __metadata("design:type", product_type_enum_1.ProductTypeEnum)
], Product.prototype, "productType", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => job_product_1.JobProduct, (job_product) => job_product.product),
    __metadata("design:type", Array)
], Product.prototype, "jobProducts", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => product_bundle_1.ProductBundle, (product_bundles_to_products) => product_bundles_to_products.productBundle),
    __metadata("design:type", Array)
], Product.prototype, "bundledProducts", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => product_bundle_1.ProductBundle, (product_bundles_to_products) => product_bundles_to_products.product),
    __metadata("design:type", Array)
], Product.prototype, "bundle", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => product_service_1.ProductService, (productService) => productService.product),
    __metadata("design:type", Array)
], Product.prototype, "services", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => product_opportunity_1.ProductOpportunity, (productOpportunity) => productOpportunity.product),
    __metadata("design:type", Array)
], Product.prototype, "opportunities", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    __metadata("design:type", product_opportunity_1.ProductOpportunity)
], Product.prototype, "productOpportunity", void 0);
Product = Product_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Product',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('products', { schema: 'public' })
], Product);
exports.Product = Product;
//# sourceMappingURL=product.js.map